module.exports = __webpack_public_path__ + "static/media/greyOpacityMarker.e2d4debf.svg";